import React from "react";
import "../../styles/Home-page-component/metrics.css";

const MetricsSection = () => {
  return (
    <section className="metrics-section">

      <div className="container">

        <h2 className="section-title">
          Our Track Record
        </h2>

        <div className="metrics-grid">

          <div className="metric-card">
            <h3>500+</h3>
            <p>Projects Delivered</p>
          </div>

          <div className="metric-card">
            <h3>50+</h3>
            <p>Enterprise Clients</p>
          </div>

          <div className="metric-card">
            <h3>98%</h3>
            <p>Success Rate</p>
          </div>

          <div className="metric-card">
            <h3>24/7</h3>
            <p>Support Available</p>
          </div>

        </div>

      </div>

    </section>
  );
};

export default MetricsSection;